export default function humanReadableTime(years: number, months: number) {
  let returnString = ''
  if (years > 0) {
    returnString += `${years} year${years > 1 ? 's' : ''}`
  }
  if (months > 0) {
    returnString += `${years > 0 ? ' and ' : ''}${months} month${months > 1 ? 's' : ''}`
  }
  return returnString
}
